import BranchApi from 'api/branch';
import events from 'lib/events';
import Header from 'components/layout/header';
import IntlWrapper from 'components/layout/intlWrapper';
import Loader from 'components/loader';
import LostCustomerPage from './lost';
import PerformancePage from './performance';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import {connectToPerformanceFile, PERFORMANCE_KEYS} from 'helpers/performanceFile';
import {connectToPOSPermissions, POS_PERMISSIONS} from 'helpers/posPermissions';
import {intlShape, injectIntl} from 'react-intl';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';

//Register in router
const render = (container, params) => {
  console.info('[UI.page.reports.sales] rendering page');
  ReactDOM.render(<IntlWrapper><LostCustomerReport subPageName={params.subPage} /></IntlWrapper>, container);
  events.publish('page-change', {page: 'reports'});
};

console.info('[UI.page.reports.sales] register route');
router.rr.add([{path: 'reports/sales/:subPage', handler: routeUtils.requireAdmin(render)}]);

class _LostCustomerReport extends Component {
  static propTypes = {
    subPageName: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
    };
  }
  componentWillMount() {
    BranchApi.getMyBranches()
      .then(branches =>
        this.setState({
          loaded: true,
          branches: branches.map(b => b.id),
          branchesFull: branches,
        }));
  }
  render() {
    let {formatMessage} = this.props.intl;
    const {subPageName} = this.props;
    const {branches, branchesFull} = this.state;
    const subPages = {
      'sales-performance': {name: formatMessage({id: 'reports.sales.performance'}), element: <PerformancePage branchesFull={branchesFull} branches={branches}/>},
      'lost-purchasing-accounts': {name: formatMessage({id: 'reports.lost.purchasing.accounts'}), element: <LostCustomerPage branchesFull={branchesFull} branches={branches} />},
    };
    const subPagesTabs = Object.keys(subPages)
      .map(sp => <a key={sp} className={subPageName === sp ? subPages[sp].className + ' active' : subPages[sp].className}
        href={'#reports/sales/' + sp}>{subPages[sp].name}
      </a>);
    const subPage = subPages[subPageName].element;

    return (
      <div className='container'>
        <div id='page-reports' >
          <div className='nav-tabs'>
            <Header mainTitle={formatMessage({id: 'reports.title'})} subTitle={formatMessage({id: 'reports.my.sales'})} mainTitleReturn='reports'/>
          </div>
          <nav className='navigation-tabs'>
            {subPagesTabs}
          </nav>
          <Loader loaded={this.state.loaded}>
            <div className='report-details'>
              {subPage}
            </div>
          </Loader>
        </div>
      </div>
    );
  }
}

const LostCustomerReport = injectIntl(bindLocaleUpdate(connectToPOSPermissions(POS_PERMISSIONS.DETAILED_REPORTING)(
  connectToPerformanceFile(PERFORMANCE_KEYS.reports)(_LostCustomerReport))
));

export default LostCustomerReport;
